var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteTrenRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aepq40t03b",
    d: "M0 0L21 0 21 26 0 26z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M15.345 26h-9.69c-.417 0-.755-.336-.755-.751s.338-.75.755-.75h9.69c.417 0 .756.335.756.75s-.339.751-.756.751",
    transform: "translate(3.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M21 5.257v6.213l-1.22.834c-2.74 1.875-5.95 2.865-9.28 2.865-3.331 0-6.54-.99-9.285-2.868L0 11.483V5.257C0 2.358 2.371 0 5.286 0h1.16v.751c0 2.223 1.818 4.032 4.054 4.032s4.054-1.809 4.054-4.032V0h1.16C18.629 0 21 2.358 21 5.257M7.956.751V0h5.088v.751c0 1.395-1.141 2.53-2.544 2.53S7.956 2.146 7.956.751m9.876 17.188c-.396 0-.718-.32-.718-.715 0-.394.322-.714.718-.714.397 0 .718.32.718.714 0 .395-.321.715-.718.715m-1.57.132c.397 0 .718.32.718.715 0 .394-.321.714-.718.714-.396 0-.718-.32-.718-.714 0-.395.322-.715.718-.715M4.738 19.5c-.397 0-.718-.32-.718-.714 0-.395.321-.715.718-.715.396 0 .718.32.718.715 0 .394-.322.714-.718.714M2.45 17.224c0-.394.321-.714.718-.714.396 0 .718.32.718.714 0 .395-.322.715-.718.715-.397 0-.718-.32-.718-.715m8.05-.553c-3.638 0-7.143-1.082-10.136-3.13L0 13.297v5.545c0 .702.456 1.55 1.066 1.975.754.516 1.543.963 2.36 1.345L.854 24.718c-.295.293-.295.769 0 1.062.148.147.341.22.534.22.194 0 .387-.073.534-.22l3.015-2.999c1.772.625 3.648.948 5.563.948 1.915 0 3.79-.323 5.563-.948l3.015 3c.147.146.34.219.534.219.193 0 .386-.073.534-.22.294-.293.294-.769 0-1.062l-2.572-2.558c.818-.382 1.61-.83 2.365-1.348.605-.421 1.061-1.269 1.061-1.971v-5.548l-.365.249c-2.992 2.047-6.497 3.13-10.135 3.13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteTrenRed);
export default __webpack_public_path__ + "static/media/transporteTrenRed.e4a96e46.svg";
export { ForwardRef as ReactComponent };